// KWANKGM03020_住宅ローンしっかり事前審査申込入力（確認）
import React, { useContext } from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterPreExaminationApplicationInputConfirmationAppHousingLoanFirmly from '../../organisms/FooterPreExaminationApplicationInputConfirmationAppHousingLoanFirmly';
import Heading from '../../molecules/Heading';
import AgreementInfo from '../../templates/AgreementInfo';
import { KeyValue } from '../../types/KeyValue';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import FileUpload from '../../templates/FileUpload';
import { status_code_list } from '../../Const';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_loading: boolean;
  is_staff: boolean;
  opened_mypage: boolean;
  moveNextStep: (step: number) => void;
  movePrevStep: () => void;
  applied: boolean;
  guarantors_num: number;
  show_error_nav: boolean;
  display_status: boolean;
  has_debtor?: boolean;
  guarantor_info: GuarantorInfo;
  callApi: (function_name: string) => Promise<any>;
  requestModule: (module_name: string) => Promise<any>;
  handleClickTempSave: () => void; // 一時保存
  agreement_info: KeyValue[];
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  loan_type: string;
  handleClickChangeDetails?: () => Promise<any>; // 申込内容を変更する
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
}

const PreExaminationHousingLoanFirmlyConfirm: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  is_loading,
  is_staff,
  moveNextStep,
  movePrevStep,
  applied,
  guarantors_num,
  show_error_nav,
  display_status,
  requestModule,
  callApi,
  guarantor_info,
  handleClickTempSave,
  has_debtor,
  agreement_info,
  shelf_info,
  setShelfInfo,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  loan_type,
  handleClickChangeDetails,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />

      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        loan_type={loan_type}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />

      {/* 連帯債務者等の同意不同意アコーディオン */}
      {/* 連帯債務者等が1人以上 && 事前審査申込登録以降に表示 */}
      {guarantors_num !== 0 && status_code >= status_code_list.preliminary_review_updating && (
        <>
          <Heading label="同意・署名" size="m" />
          <AgreementInfo agreement_info={agreement_info} heading_disabled />
        </>
      )}

      <FooterPreExaminationApplicationInputConfirmationAppHousingLoanFirmly
        applied={applied}
        is_staff={is_staff}
        reception_id={reception_id}
        reception_cd={reception_cd}
        status_code={status_code}
        moveNextStep={moveNextStep}
        movePrevStep={movePrevStep}
        requestModule={requestModule}
        handleClickTempSave={handleClickTempSave}
        has_debtor={has_debtor}
        handleClickChangeDetails={handleClickChangeDetails}
      />

      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreExaminationHousingLoanFirmlyConfirm;
